// extracted by mini-css-extract-plugin
export default {"online":"Shared_online__wLgUc","away":"Shared_away__tKsvz","buttonBar":"Shared_buttonBar__xebM1"};